exports.PROD_BACKEND_URL = "https://pdocs-backend.onrender.com/";
exports.BACKEND_URL = "http://localhost:4000/"
